import React from "react";
import { TopicScreen } from "./view";
import { TopicController } from "./controller";
import { styles } from "./styles";

export class Topic extends React.Component {
  controller = new TopicController(this.props);

  render() {
    return (
      <TopicScreen
        {...this.props}
        styles={styles}
        controller={this.controller}
      />
    );
  }
}
